export default "__VITE_ASSET__t539xE1ipgPgcnPyH$0VmQ__";